import error from '@/assets/error.svg';
import maxAttempts from '@/assets/max-attempts.svg';
import invalidCard from '@/assets/invalid-card.svg';
import insuficientFund from '@/assets/insuficient-fund.svg';
import invalidCardNumber from '@/assets/invalid-card-number.svg';
import transactionNotPermitToCardHolder from '@/assets/transaction-not-permit-to-card-holder.svg';
import invalidBrand from '@/assets/invalid-brand.svg';
import errorAuth from '@/assets/error-auth.svg';

import { faqDefault, faqCard } from '@/constants/faqs';

const errors = {
  default: {
    img: error,
    title: 'Seus dados não puderam ser validados',
    description: 'Tente novamente e verifique suas informações.',
    buttonText: 'Tentar novamente',
    faq: null,
  },
  101: {
    img: maxAttempts,
    title: 'Você atingiu o número máximo de tentativas com este cartão',
    description: 'Pague com outro cartão ou tente novamente amanhã.',
    buttonText: 'Pagar com outro cartão',
    faq: faqDefault,
  },
  103: {
    img: invalidCard,
    title: 'Não é possível concluir a compra com este cartão',
    description:
      'O cartão escolhido não é autorizado para esta compra, tente novamente com outro.',
    buttonText: 'Pagar com outro cartão',
    faq: faqCard,
  },
  104: {
    img: insuficientFund,
    title: 'O limite do seu cartão foi atingido',
    description: 'Use outro cartão para concluir esta compra.',
    buttonText: 'Pagar com outro cartão',
    faq: null,
  },
  105: {
    img: invalidCardNumber,
    title: 'Alguns dados do seu cartão não puderam ser validados',
    description:
      'Entre em contato com o banco emissor ou tente pagar com outro cartão.',
    buttonText: 'Pagar com outro cartão',
    faq: faqCard,
  },
  106: {
    img: transactionNotPermitToCardHolder,
    title: 'Houve uma falha de autenticação bancária',
    description:
      'Solicite a autorização no seu banco ou pague com outro cartão.',
    buttonText: 'Pagar com outro cartão',
    faq: faqCard,
  },
  107: {
    img: error,
    title: 'Seus dados não puderam ser validados',
    description: 'Tente novamente e verifique suas informações.',
    buttonText: 'Tentar novamente',
    faq: null,
  },
  109: {
    img: invalidBrand,
    title: 'A bandeira do seu cartão ainda não é aceita',
    description: 'Tente pagar com cartões Visa ou Mastercard.',
    buttonText: 'Pagar com outro cartão',
    faq: faqCard,
  },
  1610: {
    img: errorAuth,
    title: 'Ops, não foi possível autenticar o cartão utilizado',
    description:
      'Tente com outro cartão ou entre em contato com o banco para autorizar a compra.',
    buttonText: 'Pagar com outro cartão',
    faq: faqCard,
  },
};

export default errors;
